import {SearchApiSearchOptions, SearchQueryParams} from "../../search_api/search_constants";
import {SEARCH_SCOPES} from "../../../model/search";


export class CustomDslBuilder {

    static buildUserAccessDSL(options: SearchApiSearchOptions, query: any): any {

        if (!options.userId) {
            return null;
        }

        if (!options.searchScope) {
            options.searchScope = SEARCH_SCOPES.PUBLIC
        }

        let userAccess: any;

        if (options.hasAccess) {
            userAccess = {
                bool: {
                    must: [
                        {
                            bool: {
                                should: [
                                    CustomDslBuilder.buildOnlyMine(options),
                                    ...CustomDslBuilder.buildSharedWithMe(options),

                                ],
                                "minimum_should_match": 1
                            }
                        }
                    ]
                }
            }
        }

        if (options.onlyMine) {
            userAccess = {
                bool: {
                    should: [
                        CustomDslBuilder.buildOnlyMine(options)
                    ],
                    "minimum_should_match": 1
                }
            }
        }

        if (options.onlySharedByMe) {
            userAccess =  {
                bool: {
                    should: [
                        ...CustomDslBuilder.buildSharedByMe(options)
                    ],
                    "minimum_should_match": 1
                }
            }
        }

        if(options.onlySharedWithMe) {
            userAccess =  {
                bool: {
                    should: [
                        ...CustomDslBuilder.buildSharedWithMe(options)
                    ],
                    "minimum_should_match": 1
                }
            }
        }

        if(query){
            return {
                bool: {
                    must: [
                        query,
                        userAccess
                    ]
                }
            }
        } else {
            return userAccess;
        }

    }

    private static buildOnlyMine(options: SearchApiSearchOptions): any {
        const onlyMine = {
            term: {
                "userAccess.owner": options.userId
            }
        };
        return onlyMine
    }

    private static buildSharedByMe(options: SearchApiSearchOptions): any[] {
        const sharedByMe: any[] = [
            {
                term: {
                    "userAccess.owner": options.userId
                }
            },
            {
                range: {
                    "userAccess.scope": {
                        gte: SEARCH_SCOPES.SHARED
                    }
                }
            }
        ];

        return sharedByMe;
    }

    private static buildSharedWithMe(options: SearchApiSearchOptions): any[] {
        const sharedWithMe: any[] = [
            {
                term: {
                    "userAccess.editor": options.userId
                }
            },
            {
                term: {
                    "userAccess.viewer": options.userId
                }
            },
            {
                term: {
                    "userAccess.school": options.userSchools
                }
            }
        ];

        return sharedWithMe;
    }
}
